import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { ROUTER } from '../../constants/router';
import type { LayoutContextType } from '../../components/layout/types';
import { useOutletContext } from 'react-router-dom';

export default function Dashboard() {
  const { t } = useTranslation();
  const { setBreadcrumbItems, setHeaderTitle } = useOutletContext<LayoutContextType>();

  useEffect(() => {
    setBreadcrumbItems([
      { label: t('sidebar.dashboard'), path: ROUTER.DASHBOARD() },
      // { label: t('sidebar.fulfillment') }, // current page: no path
    ]);
    setHeaderTitle(t('sidebar.fulfillment'));
    return () => {
      setBreadcrumbItems([]);
      setHeaderTitle('');
    };
  }, [t, setBreadcrumbItems, setHeaderTitle]);

  return (
    <div className="mt-15">
      <h1 className="text-lg text-slate-900 my-5"> {t('sidebar.dashboard')}</h1>
    </div>
  );
}
